import * as React from 'react';

import CreditModel from 'src/model/credit.model';

import './CreditsPaymentDetailsMobile.scss';
import CreditsPaymentDetailsTableMobile from '../CreditsPaymentDetailsTableMobile';
import SlideMenu from 'src/components/common/SlideMenu/SlideMenu';
import LocaleFormating from 'src/translation/localeFormating';
import { startEndWithWhiteSpacesValidation } from 'src/utils/whiteSpacesValidation';
import i18n from 'src/translation/i18n';

interface ICreditsPaymentDetailsMobileProps {
  showSlideMenu: boolean;
  onCloseSlide: () => void;
  creditDetails: CreditModel;
  disposeCredit: (databaseId: number, taker: string, note: string) => void;
}

interface ICreditsPaymentDetailsMobileState {
  taker: string;
  note: string;
}

class CreditsPaymentDetailsMobile extends React.Component<
  ICreditsPaymentDetailsMobileProps,
  ICreditsPaymentDetailsMobileState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      taker: '',
      note: ''
    };
  }

  public componentDidMount() {
    this.forceUpdate();
  }

  private handleChangeTaker = (e: any) => {
    const value: any = e.target.value;

    if (
      !value ||
      (value !== ' ' && !startEndWithWhiteSpacesValidation(value))
    ) {
      this.setState({
        taker: value
      });
    }
  };

  private handleChangeNote = (e: any) => {
    const value: any = e.target.value;

    if (
      !value ||
      (value !== ' ' && !startEndWithWhiteSpacesValidation(value))
    ) {
      this.setState({
        note: value
      });
    }
  };

  private submitDisposition = () => {
    const { creditDetails } = this.props;
    this.props.disposeCredit(
      creditDetails.id,
      this.state.taker,
      this.state.note
    );

    this.props.onCloseSlide();
  };

  public render() {
    const { creditDetails } = this.props;

    return (
      <SlideMenu
        mounted={this.props.showSlideMenu}
        goBackTitle={i18n.t('common.back')}
        level={2 + 30}
        handleCloseMenu={this.props.onCloseSlide}
      >
        <div className="rp-credits-payment-details-mobile">
          <div className="row">
            <div className="col-12">
              <h2 className="rp-pay-detail-mobile-title">Payment Detail</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <h4 className="rp-pay-mobile-field--medium">Payment Id:</h4>
            </div>
          </div>
          <div className="row rp-pay-mobile-margin-bottom">
            <div className="col-12">
              <span className="rp-pay-color-blue">
                {creditDetails.paymentId}
              </span>
            </div>
          </div>
          <div className="row rp-pay-mobile-field-container">
            <div className="col-4">
              <h4 className="rp-pay-mobile-field">Cust code:</h4>
            </div>
            <div className="col-8">
              <span>{creditDetails.userInformation.clientIdentity}</span>
            </div>
          </div>
          <div className="row rp-pay-mobile-field-container">
            <div className="col-4">
              <h4 className="rp-pay-mobile-field">Pmt time:</h4>
            </div>
            <div className="col-8">
              <span>
                {LocaleFormating.formatDate(creditDetails.pmtDate, 'short')}
              </span>
            </div>
          </div>
          <div className="row rp-pay-mobile-field-container">
            <div className="col-4">
              <h4 className="rp-pay-mobile-field">Pmt type:</h4>
            </div>
            <div className="col-8">
              <span>Apply Credits</span>
            </div>
          </div>
          <div className="row rp-pay-mobile-field-container">
            <div className="col-4">
              <h4 className="rp-pay-mobile-field">Email:</h4>
            </div>
            <div className="col-8">
              <span>{creditDetails.userInformation.email}</span>
            </div>
          </div>
          <div className="row rp-pay-mobile-field-container">
            <div className="col-4">
              <h4 className="rp-pay-mobile-field">Database id:</h4>
            </div>
            <div className="col-8">
              <span>{creditDetails.id}</span>
            </div>
          </div>
          <div className="row rp-pay-mobile-field-container">
            <div className="col-4">
              <h4 className="rp-pay-mobile-field">Signature:</h4>
            </div>
            <div className="col-8">
              <span>{creditDetails.signature}</span>
            </div>
          </div>
          <div className="row rp-pay-mobile-field-container">
            <div className="col-4">
              <h4 className="rp-pay-mobile-field">
                Taker:
                {this.props.creditDetails.paymentStatus === 'PENDING' && (
                  <span className="required">*</span>
                )}{' '}
              </h4>
            </div>
            <div className="col-8">
              {creditDetails.taker ||
              this.props.creditDetails.paymentStatus !== 'PENDING' ? (
                <span>{creditDetails.taker}</span>
              ) : (
                <input
                  className="rp-pay-mobile-input"
                  type="text"
                  value={this.state.taker}
                  onChange={this.handleChangeTaker}
                />
              )}
            </div>
          </div>
          <div className="row rp-pay-mobile-field-container">
            <div className="col-4">
              <h4 className="rp-pay-mobile-field">
                Note:
                {this.props.creditDetails.paymentStatus === 'PENDING' && (
                  <span className="required">*</span>
                )}{' '}
              </h4>
            </div>
            <div className="col-8">
              {creditDetails.notes ||
              this.props.creditDetails.paymentStatus !== 'PENDING' ? (
                <span>{creditDetails.notes}</span>
              ) : (
                <input
                  className="rp-pay-mobile-input"
                  type="text"
                  value={this.state.note}
                  onChange={this.handleChangeNote}
                />
              )}
            </div>
          </div>
        </div>
        {this.props.creditDetails.paymentStatus === 'PENDING' && (
          <div className="rp-disposition-action">
            <div className="row">
              <div className="col-12 d-flex justify-content-center">
                <button
                  className="primary-button rp-disposition-button"
                  disabled={
                    this.props.creditDetails.paymentStatus !== 'PENDING'
                  }
                  onClick={this.submitDisposition}
                >
                  Disposition this payment
                </button>
              </div>
            </div>
          </div>
        )}
        {creditDetails.paymentDetails.map((payment: any) => (
          <CreditsPaymentDetailsTableMobile payment={payment} />
        ))}
      </SlideMenu>
    );
  }
}

export default CreditsPaymentDetailsMobile;
